<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">企业信息</span>
      </div>
      <el-form ref="enterpriseForm" :model="enterpriseForm" :rules="enterpriseRules" label-width="130px" style="width: 450px">
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="enterpriseForm.name" placeholder="请输入企业名称" />
        </el-form-item>
        <el-form-item label="企业身份" prop="orgType">
          <el-radio-group v-model="enterpriseForm.orgType" style="width: 700px;" @change="isSelect">
            <el-radio :label="0">电站运营商</el-radio>
            <el-radio :label="1">车辆机构</el-radio>
            <el-radio :label="2">流量方</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 电站运营商 -->
        <template v-if="changeFlag==='station'">
          <el-form-item label="运营商属性" prop="attr">
            <el-radio-group v-model="enterpriseForm.attr">
              <el-radio :label="0">自营</el-radio>
              <el-radio :label="1">加盟</el-radio>
              <el-radio :label="2">互联互通</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="运营商名称" prop="operationName">
            <el-input v-model="enterpriseForm.operationName" placeholder="请输入运营商名称" />
          </el-form-item>
          <el-form-item label="运营商秘钥" prop="operatorSecret">
            <el-input v-model="enterpriseForm.operatorSecret" placeholder="请输入运营商秘钥" />
          </el-form-item>
          <el-form-item label="消息秘钥" prop="dataSecret">
            <el-input v-model="enterpriseForm.dataSecret" placeholder="请输入消息秘钥" />
          </el-form-item>
          <el-form-item label="初始化向量" prop="dataSecretIv">
            <el-input v-model="enterpriseForm.dataSecretIv" placeholder="请输入初始化向量" />
          </el-form-item>
          <el-form-item label="签名秘钥" prop="sigSecret">
            <el-input v-model="enterpriseForm.sigSecret" placeholder="请输入签名秘钥" />
          </el-form-item>
        </template>
        <!-- 车辆机构 -->
        <!--        <template v-if="changeFlag==='vehicle'">
          <el-form-item label="企业前缀" prop="prefix">
            <el-input v-model="enterpriseForm.prefix" placeholder="请输入企业前缀" />
          </el-form-item>
        </template> -->

        <!-- 流量方 -->
        <template v-if="changeFlag==='flow'"><el-form ref="carForm" :model="enterpriseForm.car" :rules="carRules" label-width="130px">
          <el-form-item label="账号" prop="loginName">
            <el-input v-model="enterpriseForm.car.loginName" placeholder="请输入账号" />
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input v-model="enterpriseForm.car.username" placeholder="请输入用户名" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="enterpriseForm.car.password" placeholder="请输入密码" />
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="enterpriseForm.car.mobile" placeholder="请输入手机号码" />
          </el-form-item>
        </el-form>
        </template>

        <el-form-item label="企业注册地址" prop="address">
          <el-input v-model="enterpriseForm.address" placeholder="请输入企业注册地址" />
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="code">
          <el-input v-model="enterpriseForm.code" placeholder="请输入统一社会信用代码" />
        </el-form-item>
        <el-form-item label="归属城市">
          <el-cascader ref="three" v-model="enterpriseForm.cityCode" :options="optionsThree" placeholder="请选择省市区" :props="{ checkStrictly: true }" clearable />
        </el-form-item>
        <el-form-item label="签约时间">
          <el-date-picker
            v-model="enterpriseForm.signTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </el-form>
    </el-card>

    <el-card v-if="enterpriseForm.orgType===1" shadow="never">
      <div slot="header">
        <span class="title">充电限制</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="limitStationForm" :model="limitStationForm" :rules="limitStationRules" label-width="130px">
          <el-form-item label="充电阈值" prop="threshold">
            <el-input v-model="limitStationForm.threshold" placeholder="请输入充电阈值">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="是否限制充电站" prop="isLimit">
            <el-radio-group v-model="limitStationForm.isLimit">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="limitStationForm.isLimit===1">
            <el-form-item label="限制电站" prop="limitStation">
              <el-radio-group v-model="limitStationForm.limitStation">
                <el-radio label="org">选择运营商</el-radio>
                <el-radio label="station">选择电站</el-radio>
              </el-radio-group>
              <!-- 选择运营商 -->
              <div v-show="limitStationForm.limitStation==='org'" class="border">
                <el-input v-model="filterOperatorText" placeholder="输入关键字进行过滤" />
                <el-tree
                  ref="treeOperator"
                  :data="operatorTreeData"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  highlight-current
                  :props="treeDefaultProps"
                  :filter-node-method="filterNode"
                />
              </div>
              <!-- 选择电站 -->
              <div v-show="limitStationForm.limitStation==='station'" class="border">
                <el-input v-model="filterStationText" placeholder="输入关键字进行过滤" />
                <el-tree
                  ref="treeStation"
                  :data="stationTreeData"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  highlight-current
                  :props="treeDefaultProps"
                  :filter-node-method="filterNode"
                />
              </div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>

    <el-card shadow="never">
      <div slot="header">
        <span class="title">其他信息</span>
      </div>
      <el-form ref="infoForm" :model="enterpriseForm" :rules="infoRules" label-width="130px" style="width: 450px;">
        <el-form-item label="联系人" prop="contactUser">
          <el-input v-model="enterpriseForm.contactUser" placeholder="请输入联系人" />
        </el-form-item>
        <el-form-item label="联系方式" prop="contactNum">
          <el-input v-model="enterpriseForm.contactNum" placeholder="请输入联系方式" />
        </el-form-item>
        <el-form-item label="联系地址" prop="contactAddress">
          <el-input v-model="enterpriseForm.contactAddress" placeholder="请输入联系地址" />
        </el-form-item>
        <el-form-item label="联系邮箱" prop="email">
          <el-input v-model="enterpriseForm.email" placeholder="请输入联系邮箱" />
        </el-form-item>
        <el-form-item label="营业执照">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            accept=".jpg, .jpeg, .png,"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <span v-if="imageUrl" class="el-upload-action" @click.stop="handleRemove()">
              <i class="el-icon-delete" />
            </span>
            <i v-else class="el-icon-plus avatar-uploader-icon" />
            <div slot="tip" class="el-upload__tip">温馨提示：只能上传jpg/jpeg/png文件，且不超过2M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="enterpriseForm.remark" type="textarea" placeholder="请输入备注说明" />
        </el-form-item>
      </el-form>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { regionData, provinceAndCityData } from 'element-china-area-data'
import { HOST } from '@/utils/host'
export default {
  name: 'Xinzengyunyingshang',
  components: {},
  data() {
    return {
      optionsThree: provinceAndCityData, // 省市数据
      filterOperatorText: '',
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      changeFlag: 'station', // 当前企业身份控制的表单
      // 企业信息表单
      enterpriseForm: {
        name: '', // 企业名称
        orgType: 0, // 企业身份

        // 下面是分类的
        operationName: '', // 运营商名称
        operatorSecret: '', // 运营商秘钥
        dataSecret: '', // 消息秘钥
        dataSecretIv: '', // 消息秘钥初始化向量
        sigSecret: '', // 签名秘钥
        attr: 0, // 运营商属性
        // prefix: '', // 企业前缀
        car: {
          loginName: '', // 账号
          username: '', // 用户名
          password: '', // 密码
          mobile: ''// 手机号码
        },

        // 下面是公共的，都有的
        address: '', // 企业注册地址
        code: '', // 统一社会信用代码
        cityCode: [], // 归属城市
        signTime: [], // 签约时间

        contactUser: '', // 联系人
        contactNum: '', // 联系方式
        contactAddress: '', // 联系地址
        email: '', // 联系邮箱
        businessLicense: '', // 营业执照
        remark: ''// 备注说明
      },
      enterpriseRules: {
        name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        orgType: [
          { required: true, message: '请选择企业身份', trigger: 'change' }
        ],
        attr: [
          { required: true, message: '请选择运营商属性', trigger: 'change' }
        ],
        operationName: [
          { required: true, message: '请输入运营商名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入企业注册地址', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        operatorSecret: [
          { required: true, message: '请输入运营商秘钥', trigger: 'blur' }
        ],
        dataSecret: [
          { required: true, message: '请输入消息秘钥', trigger: 'blur' }
        ],
        dataSecretIv: [
          { required: true, message: '请输入初始化向量', trigger: 'blur' }
        ],
        sigSecret: [
          { required: true, message: '请输入签名秘钥', trigger: 'blur' }
        ],
        // prefix: [
        //   { required: true, message: '请输入企业前缀;', trigger: 'blur' }
        // ]
      },
      operatorTreeData: [], // 运营商树的全部数据
      stationTreeData: [], // 电站树的全部数据
      // 限制电站表单
      limitStationForm: {
        threshold: '', // 充值阈值
        isLimit: 1, // 是否限制电站
        limitStation: ''// 限制电站
      },
      limitStationRules: {
        threshold: [
          { required: true, message: '请输入充值阈值', trigger: 'blur' }
        ],
        isLimit: [
          { required: true, message: '请选择是否限制充电站', trigger: 'change' }
        ],
        limitStation: [
          { required: true, message: '请选择限制电站', trigger: 'change' }
        ]
      },
      carRules: {
        loginName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入账号手机号码', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '请输入正确的账号手机号码', trigger: 'blur' }
        ]
      },
      infoForm: {
        contactUser: '', // 联系人
        contactNum: '', // 联系方式
        contactAddress: '', // 联系地址
        email: '', // 联系邮箱
        img: '', // 营业执照
        remark: ''// 备注说明
      },
      infoRules: {
        contactUser: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactNum: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '请输入正确的联系方式', trigger: 'blur' }
        ],
        contactAddress: [
          { required: true, message: '请输入联系地址', trigger: 'blur' },
          { min: 0, max: 100, message: '联系地址长度不超过100个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入联系邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        remark: [
          { min: 0, max: 100, message: '备注长度不超过100个字符', trigger: 'blur' }
        ]
      },
      imageUrl: ''
    }
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem('token')
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  watch: {
    filterOperatorText(val) {
      this.$refs.treeOperator.filter(val)
    },
    filterStationText(val) {
      this.$refs.treeStation.filter(val)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.loadTree()
    })
  },
  methods: {
    // 加载全部运营商、电站数据
    loadTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: {
          treeDepth: 'ORG'
        },
        callback: resp => {
          this.operatorTreeData = resp
        }
      })
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: {
          treeDepth: 'STATION'
        },
        callback: resp => {
          this.stationTreeData = resp
        }
      })
    },
    onSubmit() {
      let carFormBool = true
      if (this.enterpriseForm.orgType === 2) {
        carFormBool = false
        this.$refs['carForm'].validate(valid => {
          carFormBool = valid
        })
      }

      let enterpriseFormBool = false
      this.$refs['enterpriseForm'].validate(valid => {
        enterpriseFormBool = valid
      })

      let infoFormBool = false
      this.$refs['infoForm'].validate(valid => {
        infoFormBool = valid
      })

      let limitStationFormBool = true
      if (this.enterpriseForm.orgType === 1) {
        limitStationFormBool = false
        this.$refs['limitStationForm'].validate(valid => {
          limitStationFormBool = valid
        })
      }

      // 如果表单都校验通过
      if (enterpriseFormBool && infoFormBool && carFormBool && limitStationFormBool) {
        // 进入数据提交函数
        this.submitData()
      }
    },
    // 树的节点筛选
    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    submitData() {
      // 下面是获取所有的已选择的运营商数据ID，是个array
      // this.$refs.treeOperator.getCheckedKeys()
      // 下面是获取所有的已选择的电站数据ID，是个array
      // this.$refs.treeStation.getCheckedKeys()
      // 处理部分数据
      const data = JSON.parse(JSON.stringify(this.enterpriseForm))
      data.cityCode = this.enterpriseForm.cityCode.join(',')
      if (this.enterpriseForm.signTime) {
        data.signTime = this.enterpriseForm.signTime.join(',')
      }
      // 传给后端通过判断limitStation的类型传的orgId值还是stationId值
      if (this.limitStationForm.isLimit === 1) {
        data.stationOrg = this.limitStationForm.limitStation
        if (this.limitStationForm.limitStation === 'org') {
          data.limitStationIds = this.$refs.treeOperator.getCheckedKeys().join(',')
        } else if (this.limitStationForm.limitStation === 'station') {
          data.limitStationIds = this.$refs.treeStation.getCheckedKeys().join(',')
        }
      }
			
	  data.chargingThreshold = this.limitStationForm.threshold
			
      this.$store.dispatch('form/handle', {
        url: '/org',
        data: data,
        method: 'put',
        callback: (resp) => {
          // handle(resp, o);
          this.$router.go(-1)
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.enterpriseForm.businessLicense = res.data.fileName
    },
    handleRemove() {
      this.imageUrl = ''
      this.enterpriseForm.businessLicense = ''
    },
    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')
      const isLt2M = file.size <= 2097152

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/JEPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },

    // 切换企业身份
    isSelect(val) {
      if (val === 0) {
        // 电站运营商
        this.changeFlag = 'station'
      } else if (val === 1) {
        // 车辆机构
        this.changeFlag = 'vehicle'
      } else if (val === 2) {
        // 流量方
        this.changeFlag = 'flow'
      }
    }
  }
}
</script>

<style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-upload__tip{
    color: #409EFF;
  }
  .el-upload-action {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    font-size: 0;
    color: #fff;
    text-align: center;
    line-height: 120px;
  }
  .el-upload-action:hover {
    font-size: 20px;
    background-color: #000;
    background-color: rgba(0, 0, 0, .3)
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/organManagement/addOperatormanagement.vue